<script>
import { merchantComputed } from '@store/helpers'
import dialog2Mixin from "../mixins/dialog2";

export default {
  mixins: [dialog2Mixin],
  data() {
    return {
      applicableEventGroupsList: [], // [{ title: '民生店', alias: 'aaa' }]
      callbackStore: () => {},
    }
  },
  computed: {
    ...merchantComputed,

  },
  methods: {
    onSubmit(item) {
      this.callbackStore(item)
      this.$Dialog2MixinOnDestroy(); 
    }
  }
}
</script>
<!-- section template -->
<template>
  <el-dialog
    :visible.sync="dialog2MixinVisible"
    :custom-class="`${ $style.dialogStore } isStyleLogin text-center`"
    width="378px"
    append-to-body
    @closed="$Dialog2MixinOnDestroy"
  >
    <div class="dialogStore__title">選擇店家</div>
    <div class="dialogStore__content">
      <div class="row dialogStore__list">
        <div 
          v-for="(item,index) in applicableEventGroupsList"
          :key="index"
          class="col-md-6 dialogStore__item"
          @click="onSubmit(item)"
        >
          <BaseButton
            :disabled="!item.store.state" 
            class="dialogStore__itemBox isStylePrimary isOutline2 isFull">
            <i class="fontello fontello-shop mr-2"></i>
            <div class="dialogStore__itemTitle">{{item.store.title}}</div>
          </BaseButton>
        </div >
      </div>
    </div>
  </el-dialog>
</template>
<!-- section style -->
<style lang="scss" module>
.dialogStore {
  :global {
    .dialogStore {
      &__title {
        margin-bottom: 1.5rem;
        font-family:$font-title;
        font-size: 1.5rem;
        font-weight: 600;
        line-height: 1.5;
        color: $color-primary-dark;
      }

      &__content {
        // font-size: 0.875rem;
        // line-height: 2;
        // color: $color-gray-2;
      }
      &__itemBox {
        border: 1px solid;
        border-radius: 8px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding: 1rem;
        i {
          font-size: 3.5rem;
        } 
      }
      &__itemTitle {
        font-size: 1.25rem;
      }
    }
  }
}
</style>
